import React, { ChangeEvent, FormEvent, useEffect } from "react";
import "./style.scss";
import { useParams } from "react-router";

import { Space, Form, notification } from "antd";
import { get } from "lodash-es";

import {
  useAddOrganizationNsSettingsInfo,
  useOrganizationNsSettingsInfo,
} from "hooks/api/billingEngine/useOrganizationNsSettings";

import ServiceFormWrapper from "../_common/ServiceFormWrapper";
import ServiceRate from "../_common/ServiceRate";
import { useEditServiceContext } from "../contextProviders";

export const NsSettings: React.FC = () => {
  // Current rate card
  const [value, setValue] = React.useState("");

  const [form] = Form.useForm();

  const { allowEditing: isAllowEditing, setAllowEditing } = useEditServiceContext();

  const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const onReset = () => {
    form.resetFields();
  };

  const params = useParams();
  const organizationId = get(params, "organization_id") as string;

  const { data: nsDetails, isLoading, refetch } = useOrganizationNsSettingsInfo(organizationId);

  useEffect(() => {
    setValue(nsDetails?.netSuiteId as string);
  }, [nsDetails]);

  const { mutate: addNsSettingsInfo, isLoading: isSavingNsDetails } = useAddOrganizationNsSettingsInfo();
  const onSubmit = (e?: FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    if (!isAllowEditing || isSavingNsDetails) return;
    addNsSettingsInfo(
      {
        organizationId,
        netSuiteId: value,
      },
      {
        onSuccess: () => {
          refetch();
          setAllowEditing(false);
          notification.success({
            message: "NS Customer ID has been updated successfully.",
          });
        },
      }
    );
  };

  return (
    <ServiceRate serviceName="nsSetting">
      <ServiceFormWrapper
        onSave={onSubmit}
        onCancel={onReset}
        loading={isLoading || isSavingNsDetails}
        title="NS Setting"
        saving={isSavingNsDetails}
      >
        <Space>
          <form className="form-inline" onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="ns-customer-id" className="mr-20">
                Netsuite Customer ID:{" "}
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="NS Customer ID"
                value={value}
                onChange={onValueChange}
                readOnly={!isAllowEditing}
                id="ns-customer-id"
              />
            </div>
          </form>
        </Space>
      </ServiceFormWrapper>
    </ServiceRate>
  );
};
